export default __webpack_public_path__ + "static/media/801.9a8d6dfc.png";